module.exports = __webpack_public_path__ + "img/正文装饰_1.2db52339.png";